const globalVars = {
    version: "0.1.0",
    contentType: "",
    slug: "",
    plz: "",
    plzDialog: 'plzDialog',
    restaurant: null
};
// Tabbed Menu
let openMenu = function(evt, menuName, contentType = '', slug = '') {
    globalVars.contentType = contentType;
    globalVars.slug = slug;
    if (globalVars.plzDialog === menuName && globalVars.plz != "") {
        openMenu(event, 'details-' + globalVars.contentType + '-' + globalVars.slug);
        return;
    }
    let i, menuElement, tabLinks;
    menuElement = document.getElementsByClassName("menu");
    for(i = 0; i < menuElement.length; i++)// @ts-ignore
    menuElement[i].style.display = "none";
    tabLinks = document.getElementsByClassName("tabLink");
    for(i = 0; i < menuElement.length; i++)if (tabLinks[i]) // @ts-ignore
    tabLinks[i].className = tabLinks[i].className.replace(" w3-red", "");
    if (menuName.startsWith('details-')) {
        const imageElement = document.getElementById(menuName + '-img');
        imageElement.src = imageElement.dataset.src;
    } else if (menuName.startsWith('info-')) {
        const imageElement = document.getElementById(menuName + '-img');
        imageElement.src = imageElement.dataset.src;
    }
    document.getElementById(menuName).style.display = "block";
    // @ts-ignore
    if (evt.currentTarget.firstElementChild) // @ts-ignore
    evt.currentTarget.firstElementChild.className += " w3-red";
// evt.currentTarget.firstElementChild.className += " w3-red";
};
// const plzs = "01067,01069,";
function validateForm() {
    let plz = document.forms["plz-form"]["plz"].value;
    if (globalVars.plz != "") {
        openMenu(event, 'details-' + globalVars.contentType + '-' + globalVars.slug);
        return false;
    } else if (plz == "") {
        alert("PLZ muss ausgef\xfcllt werden");
        return false;
    } else if (!plz.match(/^[0-9]{5}$/)) {
        alert("PLZ muss 5 Ziffern haben");
        return false;
    } else {
        const restaurant = getRestaurantByPlz(plz);
        if (!restaurant) {
            // CaropenMenu(event, 'info-no-plz');
            // openMenu(event, 'details-pinsa-margherita');
            openMenu(event, 'details-infos-no-plz');
            return false;
        } else {
            globalVars.plz = plz;
            globalVars.restaurant = restaurant;
            document.querySelectorAll('.details-restaurant').forEach((item)=>{
                item.innerHTML = "Restaurant:" + restaurant.title;
            });
            document.querySelectorAll('.lieferando-link').forEach((link)=>{
                link.setAttribute("href", restaurant.lieferandolink);
            });
            document.querySelectorAll('.ubereats-link').forEach((link)=>{
                link.setAttribute("href", restaurant.ubereatslink);
            });
            openMenu(event, 'details-' + globalVars.contentType + '-' + globalVars.slug);
            return false;
        }
    }
}
window.addEventListener("load", (event1)=>{
    document.body.querySelectorAll(".entry .w3-container").forEach(function(node, i) {
        // node.classList.add(i % 2?"w3-blue-grey":"w3-red");
        if (document.body.querySelectorAll(".entry .w3-container").length != i - 1) node.classList.replace("w3-black", i % 2 ? "w3-blue-grey" : "w3-red");
    });
});

//# sourceMappingURL=app.twig.2681103a.js.map
